export default __webpack_public_path__ + "static/Home-922db6ae2c66019d50653391db571e98.png";